import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
}

/**
 * ScraperIcon component
 * Represents web scraping with a globe/network icon
 * Default size: 32x32
 */
export const ScraperIcon: React.FC<IconProps> = ({ 
  size = 32, 
  color = '#101018' 
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        stroke={color}
        strokeLinejoin="round"
        strokeWidth="2"
        d="M2 16a14 14 0 1 0 28 0 14 14 0 0 0-28 0Z"
      />
      <path
        stroke={color}
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10 16c0-3.713.632-7.274 1.757-9.9C12.883 3.476 14.41 2 16 2s3.117 1.475 4.243 4.1C21.368 8.727 22 12.288 22 16s-.632 7.274-1.757 9.9C19.117 28.525 17.59 30 16 30s-3.117-1.475-4.243-4.1C10.632 23.274 10 19.713 10 16Z"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
        d="M3 20.667h26M3 11.333h26"
      />
    </svg>
  );
};

